import { esgCodes } from '@/data/esgCode';
import Filters from '@/components/analyticsPage/tabPanels/components/drawers/components/Filters';
import { useTimeSeriesQuery } from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/components/esgDataTab/components/timeSeries/hooks/useTimeSeriesQuery';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import DatePicker from '@/components/ui/datepicker';
import moment from 'moment';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ChevronDownIcon } from 'lucide-react';

const TimeSeries = () => {
  const query = useSelector((state: any) => state.analytics.dataQuery.esgData.timeSeries);
  const [setQuery] = useTimeSeriesQuery();
  const [t] = useTranslation('analytics');

  return (
    <div className="space-y-4 m-4">
      <div className="w-full space-y-1">
        <div className="font-medium">{t('Time window')}</div>
        <div className="flex items-center gap-2">
          <DatePicker
            value={query.from}
            onChange={(e) => setQuery({ from: moment(e).format('YYYY/MM/DD') })}
            className="w-full"
          />
          <DatePicker
            value={query.to}
            onChange={(e) => setQuery({ to: moment(e).format('YYYY/MM/DD') })}
            className="w-full"
          />
        </div>
      </div>
      <div className="font-medium">{t('Data type')}</div>

      <RadioGroup
        // value={query.dataType}
        defaultValue="0"
        // onChange={(e) => setQuery({ dataType: Number(e.target.value) })}
      >
        <div className="flex items-center gap-3 mb-2">
          <RadioGroupItem value={`0`} id="0" />
          <Label htmlFor="0">{t('SASB Materiality Standard')}</Label>
        </div>
        <div className="flex items-center gap-3 mb-2">
          <RadioGroupItem value={`1`} id="1" />
          <Label htmlFor="1">{t('ESG Category')}</Label>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger disabled={query.dataType === 1}>
            <Button  variant="outline" className="w-full flex items-center justify-between">
              {esgCodes.find((el) => el.general_issue_code === query.individualScore.esgCode)
                ?.general_issue_name || t('Select a ESG Category')}
              <ChevronDownIcon className="ml-2 h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {esgCodes.map((el, i) => {
              return (
                <DropdownMenuItem
                  key={i}
                  onClick={() => setQuery({ individualScore: { esgCode: el.general_issue_code } })}
                >
                  {el.general_issue_name}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      </RadioGroup>
      <div className="space-y-3">
        <div className="font-medium">{t('Index')}</div>
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <Checkbox
              checked
              disabled
              className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
            />
            ESG Category
          </div>
          <Filters filters={query.filters} setQuery={setQuery} originalFilter={query.filters} />
        </div>
      </div>
    </div>
  );
};

export default TimeSeries;
